import { render, staticRenderFns } from "./Relogio.vue?vue&type=template&id=677b46eb&scoped=true&"
import script from "./Relogio.vue?vue&type=script&lang=js&"
export * from "./Relogio.vue?vue&type=script&lang=js&"
import style0 from "./Relogio.vue?vue&type=style&index=0&id=677b46eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b46eb",
  null
  
)

export default component.exports